<template>
  <TheMenuLayout>
    <v-row>
      <v-col cols="12">
        <BaseSectionHeader>Questions</BaseSectionHeader>
      </v-col>
    </v-row>
    <div class="text-right">
      <BaseButton
        to="/conversations/new"
        color="primary"
        class="mb-4 mr-4"
      >
        Poser une question
      </BaseButton>
    </div>
    <v-list two-line>
      <template v-for="(conversation, index) in sortedConversations">
        <v-divider :key="`divider${index}`" />

        <v-list-item
          :key="conversation.id"
          avatar
          :to="`/conversations/${conversation.id}`"
        >
          <v-list-item-avatar color="primary lighten-2" class="white--text text-uppercase">
            {{ initials(conversation.admin_user.name) }}
          </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ conversation.admin_user.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-badge
                  color="primary"
                  dot
                  inline
                  v-if="conversation.unseen"
                >
                  {{ conversation.preview }}
                </v-badge>
                <span v-else>
                  {{ conversation.preview }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              {{ conversation.last_message_date | moment('from') }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              {{ conversation.archived_at ?  'Archivée' : 'En cours' }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </TheMenuLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';

export default {
  name: 'Conversations',
  components: {
    TheMenuLayout,
    BaseButton,
    BaseSectionHeader,
  },
  created() {
    this.fetchConversations();
  },
  computed: {
    ...mapState(['conversations']),
    sortedConversations() {
      return [...this.conversations].sort((a, b) => {
        const dateA = new Date(a.last_message_date);
        const dateB = new Date(b.last_message_date);
        return dateB - dateA;
      });
    },
  },
  methods: {
    ...mapActions(['fetchConversations']),
    initials(name) {
      const initials = name.split(' ');
      return `${initials[0][0]}${initials[1][0]}`;
    },
  },
};
</script>
